import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import { GameService } from '../../services/game.service';
import { AuthService } from '../../services/auth.service';
import { DataService } from '../../services/data.service';
import Swal from 'sweetalert2';
import {isEconetSubscriberValidator} from "../../utils/utils/validators/CustomValidators";

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
  signupForm!: FormGroup;
  isPasswordVisible: boolean = false;
  hasAcceptedTerms: boolean = false;
  submitClicked: boolean = false;
  isButtonDisabled: boolean = false;
  referalCode: string='';
  constructor(
      private fb: FormBuilder,
      private authService: AuthService,
      private router: Router,
      private dataService: DataService,
      private route: ActivatedRoute
  ) {}

  ngOnInit(): void {

    this.signupForm = this.fb.group({
      // email: ['', [Validators.required, Validators.email]],
      // name: ['', Validators.required],
      username: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(6)]],
      phoneNumber: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), isEconetSubscriberValidator()]],
      referralCode: [''],
      // dob: ['', Validators.required],
      // address: ['', Validators.required],
    });
    this.route.queryParams.subscribe(params => {
      const token = params['referral'];
      if (token) {
      this.referalCode = token;
      this.signupForm.get('referralCode')?.patchValue(token);
      }
    });
  }

  onSubmit(): void {
    this.submitClicked = true;
    if (this.signupForm.valid && this.hasAcceptedTerms) {
      const formValue = this.signupForm.value;
      const payload = {
        // name: formValue.name,
        userName: formValue.username,
        // email: formValue.email,
        phoneNumber: formValue.phoneNumber,
        // dob: formValue.dob,
        // address: formValue.address,
        // profilePictureUrl: 'string', // Replace 'string' with actual profile picture URL if available
        referralCode: formValue.referralCode,
        password: formValue.password
      };

      this.authService.signup(payload).subscribe(
          response => {
            if (response.success) {
              console.log("This is the response "+ response.responseBody);
              console.log("User Id is "+ response.responseBody.id);
              this.setData(response.responseBody.id);
              Swal.fire("SignUp Success!", "Proceed next", "success").then(() =>
                this.router.navigate(['/verify']) // Redirect to login page or another page
              );
            } else {
              Swal.fire("SignUp Failed!", response.message, "error");
            }
          },
          error => {
            Swal.fire("Error occurred", error.message, "error");
          }
      );
    }else {
      this.signupForm.markAllAsTouched(); // This will trigger the display of all validation messages
    }

  }
  setData(objectDetails: any) {
    this.dataService.objectDetails = objectDetails;
  }
  routeToPage(page: string) {
    this.router.navigate([page])
  }
  togglePasswordVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  protected readonly isEconetSubscriberValidator = isEconetSubscriberValidator;
  acceptTerms(): void {
    this.hasAcceptedTerms = true;

  }
  onScrolledToBottom(scrolled: boolean): void {
    if (scrolled) {
      this.isButtonDisabled = false;
    }
  }
}
